import { render, staticRenderFns } from "./TypeTwoGrid.vue?vue&type=template&id=348677c0&"
import script from "./TypeTwoGrid.vue?vue&type=script&lang=js&"
export * from "./TypeTwoGrid.vue?vue&type=script&lang=js&"
import style0 from "./TypeTwoGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports